import Head from 'next/head'

const GetFontSelectorComponent = (fontStyle) => {

    if(fontStyle && fontStyle!==''){
        switch(fontStyle){
            case 'poppins':
                return (
                    <Head>
                    <link as="font" href={'https://fonts.googleapis.com/css2?family=Poppins'} rel="stylesheet"/>
                    </Head>
                );
            case 'roboto':
                return (
                    <Head>
                    <link as="font" href={'https://fonts.googleapis.com/css?family=Roboto'} rel="stylesheet"/>
                    </Head>
                );
            case 'sans-pro':
                return (
                    <Head>
                    <link as="font" href={'https://fonts.googleapis.com/css?family=Source+Sans+Pro'} rel="stylesheet"/>
                    </Head>
                );
            case 'verdana':
                return (
                    <Head>
                    <link as="font" href={'https://fonts.googleapis.com/css?family=Verdana'} rel="stylesheet"/>
                    </Head>
                );                
            case 'trebuchet-ms':
                return (
                    <Head>
                    <link as="font" href={'https://fonts.googleapis.com/css?family=Trebuchet+MS'} rel="stylesheet"/>
                    </Head>
                );   
            case 'noto-sans':
                return (
                    <Head>
                    <link as="font" href={'https://fonts.googleapis.com/css?family=Noto+Sans'} rel="stylesheet"/>
                    </Head>
                );   
            case 'arial-narrow':
                return (
                    <Head>
                    <link as="font" href={'https://fonts.googleapis.com/css?family=Arial+Narrow'} rel="stylesheet"/>
                    </Head>
                ); 
            case 'lato':
                return (
                    <Head>
                    <link as="font" href={'https://fonts.googleapis.com/css?family=Lato'} rel="stylesheet"/>
                    </Head>
                ); 
            case 'georgia':
                return (
                    <Head>
                    <link as="font" href={'https://fonts.googleapis.com/css?family=Georgia'} rel="stylesheet"/>
                    </Head>
                ); 
            case 'courier':
              return (
                    <Head>
                    <link as="font" href={'https://fonts.googleapis.com/css?family=Courier'} rel="stylesheet"/>
                    </Head>
                ); 
            case 'comic-sans-ms':
                return (
                    <Head>
                    <link as="font" href={'https://fonts.googleapis.com/css?family=Comic+Sans+MS'} rel="stylesheet"/>
                    </Head>
                ); 
            case 'noto-sans':
                return (
                    <Head>
                    <link as="font" href={'https://fonts.googleapis.com/css?family=Noto+Sans'} rel="stylesheet"/>
                    </Head>
                ); 
            case 'default-text':
                return null;
            default:
                return null
        }
    }
    else{
        return null
    }
};

export default GetFontSelectorComponent;